import { useAuthMutation } from "@bn/api";
import { resendConfirmationEmail } from "@api";

export const useResendEmail = () =>
  useAuthMutation<undefined, AxiosApiError, { email: string }>(
    resendConfirmationEmail
  );
